import moment from 'moment';
import { PaymentType } from '../redux/createOrder/types';

/**
 * Corpo de requisicao para criar um pedido checkout na pagarme
 * @param {any} items | Itens do pedidos
 * @param {any} clientInfo | Informacoes do cliente
 * @param {any} paymentMethods | methodos de pagamento
 * @param {any} paymentType | Tipo de pagamento
 * @param {number} orderTotal | Numero inteiro do total
 * @param {string} code | Codigo do pedido
 */
export const createOrderData = (
	items: any,
	clientInfo: any,
	paymentMethods: any,
	paymentType: any,
	orderTotal: number,
	shippingPrice?: number,
	code?: string,
	discountPrice?: number
) => {
	const paymentsBody: Partial<PaymentType> = {};
	let newItems: any = [];

	const deliveryValue = {
		amount: shippingPrice,
		description: 'Frete',
		quantity: 1,
	};
	const discountValue = {
		amount: discountPrice,
		description: 'Desconto',
		quantity: 1,
	};

	if (
		shippingPrice &&
		shippingPrice > 0 &&
		discountPrice &&
		discountPrice > 0
	) {
		newItems = [...items, discountValue, deliveryValue];
	} else if (discountPrice && discountPrice > 0) {
		newItems = [...items, discountValue];
	} else if (shippingPrice && shippingPrice > 0) {
		newItems = [...items, deliveryValue];
	} else {
		newItems = items;
	}

	const boletoJson = (paymentsBody.boleto = {
		due_at: moment(paymentType.dueAt, 'DD-MM-YYYY').format(
			'YYYY-MM-DD[T]20:mm:ss'
		),
	});

	const pixJson = (paymentsBody.pix = {
		// expires_in: paymentType.expiresIn,
		expires_at: moment(paymentType.expiresAt, 'DD-MM-YYYY').format(
			'YYYY-MM-DD[T]20:mm:ss'
		),
	});

	const creditCardJson = (paymentsBody.credit_card = {
		capture: true,
		installments: paymentType.installments,
		statement_descriptor: paymentType.softDescriptor
			? paymentType.softDescriptor
			: '',
	});

	const boleto = paymentMethods.includes('boleto') ? boletoJson : '';
	const credit_card = paymentMethods.includes('credit_card')
		? creditCardJson
		: '';
	const pix = paymentMethods.includes('pix') ? pixJson : '';
	const clientCpf = clientInfo.cpf.replace(/[,.-]/g, '');
	const clientCpfClean = clientCpf.replace(/\s/g, '');

	let body: any = {
		items: newItems,
		customer: {
			type: 'individual',
			name: clientInfo.name ? clientInfo.name : '',
			email: clientInfo.email ? clientInfo.email : '',
			document: clientCpfClean || '',
		},
		payments: [
			{
				amount: orderTotal,
				payment_method: 'checkout',
				checkout: {
					billing_address_editable: true,
					customer_editable: true,
					accepted_payment_methods: paymentMethods,
					success_url: `https://${window.location.hostname}`,
					credit_card,
					boleto,
					pix,
					skip_checkout_success_page: !Boolean(boleto) && !Boolean(pix),
				},
			},
		],
	};

	if (code) {
		body = {
			...body,
			code,
		};
	}

	return body;
};

/**
 * Corpo de requisicao para buscar uma oferta na roval
 * Deve ser enviado em uma linha
 * @param {string} id | ID da oferta
 */
export const budgetBody = (id: string) => {
	return {
		query: `SELECT orc.cdfil || '|' || orc.nrorc || '|' || orc.serieo AS IdOrcamento , orc.cdfil || '|' || orc.nrorc AS IdNumeroOrcamento , orc.cdfil AS IdFilial , fil.DESCRFIL AS Filial , orc.nrorc AS Numero , orc.serieo AS Serie , prt.NOMEMED AS NomePrescritor , esp.PARAMETRO AS EspecialidadePrescritor , prof.PARAMETRO AS ProfissaoPrescritor , orc.ufcrm AS UFCRM , orc.nrcrm AS NumeroCRM , orc0.VRRQU AS ValorOrcamento , orc0.VRDSC AS ValorDescontoOrcamento , orc0.VRTXA AS ValorTaxaOrcamento , orc.PRREAL AS ValorSerie , orc.prcobr AS ValorCobrancaSerie , cl.EMAIL AS EmailCliente , orc.VRTXA AS ValorTaxaSerie , orc.VRDSC AS ValorDescontoSerie , orc.CDCONRE|| '|' || orc.CDFUNRE as IdFuncionarioOrcamento , func.NOMEFUN AS NomeFuncionario , orc.VOLUME AS QtdOuVolume , orc.UNIVOL AS UnidadeVolume , orc.QTFOR AS QtdFormula , orc.qtaprov AS QtdAprovada , orc.dtentr AS DataEntrada , cl.NOMECLI AS NomeCliente , cl.NRCNPJ AS CPFCliente , prod.descr AS Produto , prod.grupo AS GrupoProduto , prod.CDPRO AS IdProduto , auxFamil.parametro AS Familia ,CASE WHEN prod.setor in ('510', '511') THEN 'Roval' ELSE 'Terceiros' END AS SetorProduto , orc1.ITEMID AS Item , orc1.QUANT AS QuantidadeItem , orc1.UNIDA AS UnidadeMedida , orc.qtaprov AS QuantidadeAprovado , orc0.* FROM FC15100 orc LEFT JOIN fc15000 orc0 ON orc0.cdfil = orc.cdfil AND orc0.nrorc = orc.nrorc LEFT JOIN fc15110 orc1 ON orc1.cdfil = orc.cdfil AND orc1.nrorc = orc.nrorc AND orc1.serieo = orc.serieo LEFT JOIN fc04300 prt3 ON prt3.pfcrm = orc.PFCRM and prt3.UFCRM = orc.UFCRM AND prt3.NRCRM = orc.NRCRM LEFT JOIN FC04000 prt ON prt.pfcrm = orc.PFCRM and prt.UFCRM = orc.UFCRM AND prt.NRCRM = orc.NRCRM LEFT JOIN FC99999 esp ON esp.ARGUMENTO = 'ESPEC' AND esp.SUBARGUM = prt3.CDESP LEFT JOIN FC99999 prof ON esp.ARGUMENTO = 'PFCRM' AND esp.SUBARGUM = orc.pfcrm LEFT JOIN FC01000 fil ON fil.cdfil = orc.cdfil LEFT JOIN FC08000 func ON func.CDCON = orc.CDCONRE AND func.CDFUN = orc.CDFUNRE LEFT JOIN FC07000 cl ON cl.CDCLI = orc.CDCLI LEFT JOIN FC03000 prod ON prod.CDPRO = orc1.cdprin LEFT JOIN FC99999 auxFamil ON trim(auxFamil.argumento) = 'Familia' AND trim(auxFamil.subargum) = trim(prod.famil) WHERE orc.cdfil IN (1,3,5,9,13,19) AND orc.cdfil || '|' || orc.nrorc = '${id}'`,
	};
};

export const budgeItemsBody = (id: string | undefined) => {
	const indexDivisor = id?.indexOf('/') || 0;
	const filial = id?.slice(0, indexDivisor);
	const budget = id?.slice(indexDivisor + 1);
	return {
		query: `SELECT F100.CDFIL,
    F100.NRORC,
    F100.SERIEO,
    F100.TPFORMAFARMA,
    F100.QTCONT,
    F100.VOLUME,
    F100.UNIVOL,
    F100.QTFOR QUANTIDADE,
    F110.DESCR NOME,
    F110.CDPRO CODIGO,
    F100.PRCOBR PRECO
FROM FC15100 F100
INNER JOIN FC15110 F110
  ON F100.CDFIL = F110.CDFIL
    AND F100.NRORC = F110.NRORC
    AND F100.SERIEO = F110.SERIEO
    AND F110.ITEMID = 1
WHERE F100.DTENTR >= DATEADD(-3 MONTH TO CURRENT_DATE)
  AND F100.CDFIL = ${filial}
  AND F100.NRORC = ${budget}
ORDER BY F100.SERIEO`,
	};
};

export const resaleItemsBody = (id: string | undefined) => {
	if (id && Number.isNaN(parseInt(id))) {
		return {
			query: `SELECT PRO.CDPRO CODIGO,
      PRO.DESCRPRD NOME,
      PRO.UNIDA UNIDADE,
      PRO.PRVEN PRECO
      FROM FC03000 PRO
      WHERE PRO.SITUA = 'A'
      AND PRO.GRUPO = 'R'
      AND (
         PRO.DESCRPRD LIKE '%${id.toUpperCase()}%'
      )
    ORDER BY PRO.DESCRPRD`,
		};
	}
	return {
		query: `SELECT PRO.CDPRO CODIGO,
      PRO.DESCRPRD NOME,
      PRO.UNIDA UNIDADE,
      PRO.PRVEN PRECO
      FROM FC03000 PRO
      WHERE PRO.SITUA = 'A'
      AND PRO.GRUPO = 'R'
      AND (
         PRO.CDPRO = ${id}
      )
    ORDER BY PRO.DESCRPRD`,
	};
};

export const clientBody = (cpf: string | undefined) => {
	return {
		query: `SELECT CLI.CDCLI CODIGO,
    CLI.NOMECLI NOME,
    CLI.DTNAS DATA_NASCIMENTO,
    CLI.NRCNPJ CPF_CNPJ,
    CLI.EMAIL EMAIL,
    EDR.ENDER ENDERECO,
    EDR.ENDNR NUMERO,
    EDR.ENDCP COMPLEMENTO,
    EDR.BAIRR BAIRRO,
    EDR.MUNIC MUNICIPIO,
    EDR.UNFED UF,
    EDR.NRCEP CEP,
    EDR.NRDDD DDD,
    EDR.NRTEL TELEFONE,
    EDR.NRDDD2 DDD_2,
    EDR.NRTEL2 TELEFONE_2,
    EDR.NRDDDFAX DDD_CELULAR,
    EDR.NRFAX CELULAR
  FROM FC07000 CLI
    LEFT JOIN FC07200 EDR 
      ON CLI.CDCLI = EDR.CDCLI
    WHERE 
       CLI.NRCNPJ = '${cpf?.replace(/[,.-]/g, '')}'
  ORDER BY CLI.NOMECLI`,
	};
};

// SELECT F100.CDFIL,
//     F100.NRORC,
//     F100.SERIEO,
//     F100.TPFORMAFARMA,
//     F100.QTCONT,
//     F100.VOLUME,
//     F100.UNIVOL,
//     F100.QTFOR,
//     F110.DESCR,
//     F100.PRCOBR
// FROM FC15100 F100
// INNER JOIN FC15110 F110
//   ON F100.CDFIL = F110.CDFIL
//     AND F100.NRORC = F110.NRORC
//     AND F100.SERIEO = F110.SERIEO
//     AND F110.ITEMID = 1
// WHERE F100.DTENTR >= DATEADD(-3 MONTH TO CURRENT_DATE)
//   AND F100.CDFIL = {filial}
//   AND F100.NRORC = {orcamento}
// ORDER BY F100.SERIEO
// Revenda = 10975748278779911
// Orçamentos = 9/620161 9/625108 19/106884
